import { Link } from 'react-router-dom';
import { AlertTriangle, Clock } from 'lucide-react';
import { Alert, AlertDescription } from '@/components/ui/alert';
import type { WorkOrder } from '@/types/maintenance';
import { timeInState } from '@/lib/workOrderUtils';

interface Props {
  workOrders: WorkOrder[];
}

export function LineDownBanner({ workOrders }: Props) {
  const lineDownWOs = workOrders.filter(
    wo => wo.impact === 'line_down' && wo.status !== 'closed',
  );

  if (lineDownWOs.length === 0) return null;

  return (
    <Alert variant="destructive" className="border-[hsl(var(--status-red))] bg-[hsl(var(--status-red-bg))]">
      <AlertTriangle className="h-4 w-4 text-[hsl(var(--status-red))]" />
      <AlertDescription>
        <div className="flex items-center gap-2 mb-1.5">
          <span className="font-bold text-[hsl(var(--status-red))] text-sm uppercase tracking-wide">
            Line Down — {lineDownWOs.length} active {lineDownWOs.length === 1 ? 'event' : 'events'}
          </span>
        </div>
        <div className="space-y-1">
          {lineDownWOs.map(wo => (
            <Link
              key={wo.id}
              to={`/maintenance/work-orders/${wo.id}`}
              className="flex items-center gap-4 text-xs text-foreground hover:underline"
            >
              <span className="font-semibold shrink-0">{wo.mold?.mold_id || wo.mold_id}</span>
              {wo.machine && (
                <span className="text-muted-foreground shrink-0">@ {wo.machine.name}</span>
              )}
              <span className="text-muted-foreground truncate flex-1">
                {wo.failure_text || wo.problem_description}
              </span>
              {wo.assignee && (
                <span className="text-muted-foreground shrink-0">{wo.assignee.name}</span>
              )}
              <span className="flex items-center gap-0.5 text-muted-foreground shrink-0">
                <Clock className="h-3 w-3" />
                {timeInState(wo)}
              </span>
            </Link>
          ))}
        </div>
      </AlertDescription>
    </Alert>
  );
}
